import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import VideoStream from "./VideoStream";
import DeviceList from "./DeviceList";
import Transliterator from "./Translate";
import EventsList from "./Events";
import Scroll from "./Scroll";
import { useDataContext } from "./contexts/DataProvider";
import welcome from  "./1.png";
import VideoPlayer from "./videoPlayer";
import VideoStreamW from "./TestComp";

const CustomLayoutWithMarquee = () => {
  const { dashboard } = useDataContext();

  const currentSetting =
  dashboard.length > 0 ? dashboard[0].setting_name : null;
  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100vh", width: "100vw", overflow: "hidden" }}
    >
      <div className="d-flex" style={{ height: "100%" }}>
        <div
          style={{
            width: "100%", // Adjust width as needed
            height: "100%", // Adjust height as needed
            // backgroundColor: "#f8d7da",
            // border: "1px solid #000",
            background:'white',
            overflow: "hidden",
          }}
        >
         { currentSetting == "live" && <VideoStream currentSetting = {
          "live"
         }/>}
          
         { currentSetting == "kirtan" && <VideoStream currentSetting = {"kirtan"}/>}

          {/* <Transliterator/> */}
          {currentSetting == "welcome" && <img style={{width:'100%'}} src={welcome} /> }

          {currentSetting =="gurbani" && <VideoPlayer/>}
        </div>

        {/* <EventsList /> */}
      </div>

      {/* Bottom Section (Aligned with Main Video Div) */}
      {/* <Scroll /> */}
    </div>
  );
};

export default CustomLayoutWithMarquee;
